import { QUESTION_TYPE } from '@src/app-components/dynamic-form/dynamic-form.validation';
import { resolveNonPcnConfigForRequest } from '@src/app-pages/Forms/registry/configs/nonPcn/nonPcnConfig';

type YesNoAnswer = {
  [key: string]: string;
};

const setYesNoAnswer = (val: boolean) => (val === true ? 'Yes' : 'No');

// STORE FORMAT --> RHF FORMAT (getNonPcn)
// convert API answer obj to internal RHF answer format
// returns the RHF object used in the NPR RHF
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const formatNonPcnRhfAnswers = (formData: any) => {
  const cfg = resolveNonPcnConfigForRequest({
    requestType: formData?.request?.requestType,
    formVersion: formData?.request?.formVersion,
  });

  const rhfDefaultValues: { [key: string]: string | boolean | undefined } = {};
  const nonPcnData = formData?.request?.nonPCNRequests?.[0] ?? {};

  Object.keys(nonPcnData).forEach((key) => {
    const questionId = cfg.nonPcnQuestionIdByName[key as keyof typeof cfg.nonPcnQuestionIdByName];
    const questionData = questionId ? cfg.questionsById[questionId] : undefined;

    // Format values
    let val = nonPcnData[key];

    if (!questionId || !questionData) {
      rhfDefaultValues[key] = val as string | boolean | undefined;
      return;
    }

    if (questionData.questionTypeId === QUESTION_TYPE.yesNo) {
      if (nonPcnData[key] === 'Yes') val = true;
      if (nonPcnData[key] === 'No') val = false;
    }

    if (questionData.questionTypeId === QUESTION_TYPE.option) {
      if (nonPcnData[key] === 'N/a') val = 'Not Applicable';
    }

    rhfDefaultValues[questionData.questionName || key] = val as string | boolean | undefined;
  });
  return rhfDefaultValues;
};

// STORE FORMAT --> API FORMAT (updateNPR)
// convert internal answer obj to API answer format sent in the update request
// returns the No Permit Required payload object used in the updateNPR endpoint
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const formatNonPcnAnswerSet = (formData: any) => {
  const cfg = resolveNonPcnConfigForRequest({
    requestType: formData?.request?.requestType,
    formVersion: formData?.request?.formVersion,
  });

  const nonPcnData = formData?.request?.nonPCNRequests?.[0] ?? {};
  const formattedObj: YesNoAnswer = {};

  Object.keys(nonPcnData).forEach((key) => {
    let val = nonPcnData[key];

    const questionId = cfg.nonPcnQuestionIdByName[key as keyof typeof cfg.nonPcnQuestionIdByName];
    const questionData = questionId ? cfg.questionsById[questionId] : undefined;

    if (questionData?.questionTypeId === QUESTION_TYPE.yesNo) {
      val = typeof nonPcnData[key] === 'boolean' ? setYesNoAnswer(nonPcnData[key] as boolean) : nonPcnData[key];
    }

    if (questionData?.questionTypeId === QUESTION_TYPE.option) {
      val = nonPcnData[key] === 'Not Applicable' ? 'N/a' : nonPcnData[key];
    }

    formattedObj[key] = val as string;
  });

  formData.request.nonPCNRequests = [formattedObj];
  return formData;
};
